import React from 'react';

function Later() {
  return (
    <div>Later</div>
  );
}

export default Later;
